export default __webpack_public_path__ + "static/media/macos_logo_white.0cea5312.png";